import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-reset-password.component.less'],
  templateUrl: './tellent-reset-password.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentResetPasswordTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentResetPasswordTemplateData>;
}

export type TellentResetPasswordTemplateData = {
  header: string;
  subheader: string;
  footer: {
    text: string;
    label: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
};

export const TellentResetPasswordTemplateMocks: TellentResetPasswordTemplateData[] = [
  {
    header: 'Password reset request',
    subheader:
      'Hi %{user_name}! 👋 It looks like you want to reset your password. If you really do, click this button.',
    footer: {
      text: 'Need help?',
      label: 'support@tellent.com',
    },
    primary_cta: {
      href: 'http://recruitee.com',
      label: 'Reset password',
    },
  },
];
